export enum TermsAndConditions {
    UAV = 'UAV',
    'UAV-GC' = 'UAV-GC',
    DNR = 'DNR',
    OTHER = 'other',
}
